import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _URLSearchParams from "@babel/runtime-corejs3/core-js-stable/url-search-params";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React from "react";
import { connect } from "react-redux";
import FilterButton from "orion/lib/filterButton";
import FormGroup from "orion/lib/formGroup";
import Label from "orion/lib/label";
import Loader from "orion/lib/loader";
import Select from "orion/lib/select";
import PropTypes from "prop-types";
import { useDruvaAlerts } from "../../contexts/DruvaAlertsContext";
import { setFilters } from "../../actionCreators/alertsListActionCreators";
import { useNavigate, useLocation } from "react-router-dom";
var alertSeverityOptions = [{
  label: "All",
  value: "All"
}, {
  label: "Critical",
  value: "Critical"
}, {
  label: "Warning",
  value: "Warning"
}];

var FilterAlertsButton = function FilterAlertsButton(_ref) {
  var isLoading = _ref.isLoading,
      alertTypesOptions = _ref.alertTypesOptions,
      filters = _ref.filters,
      setFilters = _ref.setFilters;
  var navigate = useNavigate();

  var _useLocation = useLocation(),
      search = _useLocation.search;

  var _useDruvaAlerts = useDruvaAlerts(),
      isMsp = _useDruvaAlerts.isMsp;

  var params = new _URLSearchParams(search);
  var severity = params.get("severity");

  var defaultSeverity = severity && severity.charAt(0).toUpperCase() + _sliceInstanceProperty(severity).call(severity, 1).toLowerCase();

  var _React$useState = React.useState(defaultSeverity ? [{
    fieldName: "alertSeverity",
    value: {
      label: defaultSeverity,
      value: defaultSeverity
    }
  }] : isMsp ? [] : [{
    fieldName: "alertSeverity",
    value: {
      label: "Critical",
      value: "Critical"
    }
  }]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      appliedFilters = _React$useState2[0],
      setAppliedFilters = _React$useState2[1];

  var handleReset = function handleReset() {
    setAppliedFilters([]);
  };

  React.useEffect(function () {
    navigate({
      search: ""
    });
  }, []);
  return /*#__PURE__*/React.createElement(FilterButton, {
    filterTitle: "Filters",
    onSubmit: function onSubmit(value) {
      setFilters(value);
    },
    filters: [{
      title: "Alert Type",
      fieldName: "alertTypeName"
    }, {
      title: "Alert Severity",
      fieldName: "alertSeverity"
    }],
    renderFilters: function renderFilters(formikProps) {
      return /*#__PURE__*/React.createElement(Loader, {
        isLoading: isLoading
      }, /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
        text: "Alert Type"
      }), /*#__PURE__*/React.createElement(Select, {
        name: "alertTypeName",
        type: "select",
        options: alertTypesOptions,
        value: _valuesInstanceProperty(formikProps).alertTypeName,
        validationProps: formikProps,
        onChange: function onChange(value) {
          return setAppliedFilters(function (appliedFilters) {
            var _context;

            var data = _filterInstanceProperty(appliedFilters).call(appliedFilters, function (f) {
              return f.fieldName !== "alertTypeName";
            });

            return _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(data), [{
              fieldName: "alertTypeName",
              value: value
            }]);
          });
        }
      })), /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(Label, {
        text: "Alert Severity"
      }), /*#__PURE__*/React.createElement(Select, {
        name: "alertSeverity",
        type: "select",
        options: alertSeverityOptions,
        value: _valuesInstanceProperty(formikProps).alertSeverity,
        validationProps: formikProps,
        onChange: function onChange(value) {
          return setAppliedFilters(function (appliedFilters) {
            var _context2;

            var data = _filterInstanceProperty(appliedFilters).call(appliedFilters, function (f) {
              return f.fieldName !== "alertSeverity";
            });

            return _concatInstanceProperty(_context2 = []).call(_context2, _toConsumableArray(data), [{
              fieldName: "alertSeverity",
              value: value
            }]);
          });
        }
      })));
    },
    onReset: handleReset,
    appliedFilters: appliedFilters
  });
};

FilterAlertsButton.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  alertTypesOptions: PropTypes.array.isRequired,
  filters: PropTypes.object.isRequired
};
var mapDispatchToProps = {
  setFilters: setFilters
};
export default connect(null, mapDispatchToProps)(FilterAlertsButton);